/**
 * PAPPO — Verification Service
 * Verificação de conta Nível 00 (email/SMS OTP).
 */

import { apiPost } from './api';

export type VerificationTipo = 'email' | 'sms';

/** Pede o envio de um código (email ou sms). Em dev, o código sai no log do backend. */
export async function enviarCodigo(tipo: VerificationTipo) {
  return apiPost<{ already?: boolean }>('/auth/verificacao/enviar', { tipo });
}

/** Confirma o código; em sucesso devolve o estado das flags. */
export async function confirmarCodigo(tipo: VerificationTipo, codigo: string) {
  return apiPost<{
    email_verified: boolean;
    phone_verified: boolean;
    pode_conversar: boolean;
  }>('/auth/verificacao/confirmar', { tipo, codigo });
}
